export const CONSENT_STORAGE_KEY = 'cookie-consent';
export const CONSENT_EVENT_NAME = 'ny-cookie-consent';

export type ConsentChoice = 'accepted' | 'declined';
